<section class="main-section usercenter-section independent-entity-section">
  <div class="row justify-content-end mb-2">
    <div class="col-md-2">
    </div>
  </div>
  <div>
    <app-school-details
      [isCurrentTab]="activeTab"
      [clientAccountId]="0"
      [independentSchoolData]="schoolData"
      [totalRecords]="schoolData.length ? schoolData[0].totalRecords : 0"
      (paginationData)="
        getGridData($event.sortColumn, $event.sortDirection, $event.pageIndex * $event.pageSize, $event.pageSize)
      "
      [openedFromIndependentSchool]="true"
    ></app-school-details>
  </div>
</section>
